/**
 * Parses `document.cookie` into a name → decoded value map. Values that fail to decode are kept
 * raw.
 */
export const readCookies = (): Record<string, string> => {
  const cookies: Record<string, string> = {}
  for (const pair of document.cookie.split('; ')) {
    const separatorIndex = pair.indexOf('=')
    if (separatorIndex <= 0) continue
    const name = pair.slice(0, separatorIndex)
    const rawValue = pair.slice(separatorIndex + 1)
    try {
      cookies[name] = decodeURIComponent(rawValue)
    } catch {
      cookies[name] = rawValue
    }
  }
  return cookies
}
